<template>

<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">NEW CREDIT APPLICANT</div>
    <div>
      <div class="e-card-content">
      <div class="container2">
        <div class="leftcol">
        <div class="form-row">
          <div style="width:30%;" class="form-row-input">
            <ejs-autocomplete
                ref="autocompleteUsersRef"
                :dataSource='usersData'
                :placeholder="waterMark"
                :fields="userFields"
                :minLength="userMinLength"
                sortOrder="sortOrder"
                :filterType="filterType"
                float-label-type="Always"
                v-model="selectedUserName"
                :change="onUserSelection"
                width = 450
            >
            </ejs-autocomplete>
          </div>
          <div style="width:50%;" class="form-row-input">
            <font-awesome-icon :icon="['fas', 'search']" />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%;" class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Applicant Company"
              v-model="userCompany"
            />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%;" class="form-row-input">
            <ejs-textbox
              float-label-type="Always"
              placeholder="Email"
              v-model="userEmail"
            />
          </div>
        </div>
        <div class="form-row">
          <div style="width:50%;" class="form-row-input">
            <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Add Credit Limit:"
              format = 'C2'
             :showSpinButton='numericSpin'
              v-model="userCredit.creditTotalAmount" />
          </div>
        </div>
        </div>
        </div>
        <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onProcessClick"
                      cssClass="e-info margin-button">Save</ejs-button>
        <ejs-button v-on:click.native="onCancelClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
      </div>
   </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin, AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
import { SwitchPlugin } from '@syncfusion/ej2-vue-buttons';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { FETCH_USER_PROFILES } from '@/modules/user-accounts/store';
import { GET_SELECTED_USER_COMPANY_BY_USERID, PROCESS_USER_CREDIT } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(DatePickerPlugin);
Vue.use(SwitchPlugin);

export default {
  name: 'transactionEdit',
  components: {
  },

  data() {
    return {
      waterMark: 'Applicant Name:',
      usersData: [],
      userFields: {
        value: 'userFullInfo',
      },
      userMinLength: 3,
      selectedUserId: '',
      selectedUserName: '',
      title: 'New User Credit',
      userEmail: '',
      userCompany: '',
      userFullName: '',
      creditRemaining: 0,
      userCredit: {
        userId: '',
        creditTotalAmount: 0,
        creditUsed: 0,
        creditActive: true,
        description: '',
      },
      dateMarker: 'Refund Date(yyyy-mm-dd)',
      dateFormat: 'yyyy-MM-dd',
      paymentPaidDate: null,
      numericSpin: false,
      filterType: 'Contains',
    };
  },

  created() {
    this.bootstrap();
  },

  computed: {
  },

  methods: {
    async bootstrap() {
      // load Users heere
      try {
        await this.$store.dispatch(FETCH_USER_PROFILES);
      } catch (err) {
        console.error('Fetch Users bootstrap err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }

      const userProfilesPlus = this.$store.getters.userProfiles.map((profile) => ({ ...profile, userFullInfo: `${profile.userFullName} , ${profile.email}` }));
      this.userData = userProfilesPlus;
      this.$refs.autocompleteUsersRef.ej2Instances.dataSource = this.userData;
    },

    async onUserSelection(e) {
      const { itemData } = e;
      this.userEmail = itemData.email;
      this.userCredit.userId = itemData.userId;

      const userCreditList = this.$store.getters.accountingUserCredits;
      // compare email with the list
      this.$parent.notificationToasts.length = 0;
      const userCreditFound = userCreditList.find((x) => x.email === this.userEmail);

      if (userCreditFound !== undefined) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'UserCredit account with this email already exists!',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }

        this.$router.push('/accounting/manage-accounting');
        return;
      }

      try {
        await this.$store.dispatch(GET_SELECTED_USER_COMPANY_BY_USERID,
          { userId: this.userCredit.userId }).then(() => {
          if (this.$store.getters.accountingSelectedUserCompany !== null) {
            const company = this.$store.getters.accountingSelectedUserCompany;
            this.userCompany = company.legalName;
          }
        });
      } catch (err) {
        console.error(err);
      }
    },

    async onProcessClick() {
      this.$parent.notificationToasts.length = 0;
      try {
        const credit = this.userCredit;
        await this.$store.dispatch(PROCESS_USER_CREDIT, { data: credit }).then(() => {
          this.$parent.notificationToasts.push({
            title: 'Success!',
            content: 'New UserCredit created successfully.',
            cssClass: 'e-toast-success',
            timeOut: 5000,
          });
        });
      } catch (error) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: error.message,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }

      this.$router.push('/accounting/manage-accounting');
    },
    onCancelClick() {
      this.$router.push('/accounting/manage-accounting');
    },
  },

};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}
.container2 {
  display: flex;
  flex-flow: row;
  min-height: 50px;
  text-align: left;
  border-style: groove;
  margin: 10px;
  width:95%;
}

.leftcol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.middlecol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.colrow {
  margin: 8px;
  flex: 1;
}

.data-flex-row{
  display: flex;
  flex-direction: row;
}

.data-flex-cell{
  flex: 1;
}
</style>
